module.exports = __webpack_public_path__ + "img/banner.30bdf13d.png";